import routerOptions0 from "/codebuild/output/src3082375315/src/codestar-connections.us-east-1.amazonaws.com/git-http/867915409343/us-east-1/9e561835-8a2f-4d1c-9907-8c0e7ae28d0b/geekcafe/geek-cafe-web-site/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}